export default __webpack_public_path__ + "static/media/Email.a6fc941c.svg";